export const getAssetKey = (name) => name.replace(/ |-/g, '');
